// extracted by mini-css-extract-plugin
export var Bank = "index-module--Bank--Zygn6";
export var highlights = "index-module--highlights--mblvK";
export var materialGroup = "index-module--materialGroup--PAUzi";